var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('originator-rule',{ref:"originatorRule",attrs:{"transport":_vm.smsTransport}})}
var staticRenderFns = []

export { render, staticRenderFns }